import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../interviewAI/NotificationContext";
import { submitContactForm, generateCaptcha } from "../services/api";
import { completeJourney, createTrackingContext } from "../services/webTracking";
import demoIllustration from "../assets/ModalIcon/demo-illustration.svg";
import demoPanelBackground from "../assets/ModalIcon/demo-panel-bg.svg";
import logo from "../../interviewAI/assets/newlogo/VIRIQO_HIRES_Logo.png";
import tailoredIcon from "../assets/ModalIcon/tailored.svg";
import expertGuidanceIcon from "../assets/ModalIcon/expert-guidance.svg";
import useCasesIcon from "../assets/ModalIcon/use-cases.svg";
import interFont from "../assets/ModalIcon/inter-variable.woff2";
import jakartaFont from "../assets/ModalIcon/plus-jakarta-sans-variable.woff2";

const TT_CONTACT_MODAL_CSS = `

@font-face{font-family:"TTModalInter";src:url("${interFont}") format("woff2");font-weight:100 900;font-display:swap}
@font-face{font-family:"TTModalJakarta";src:url("${jakartaFont}") format("woff2");font-weight:200 800;font-display:swap}
.tt-demo-modal,.tt-demo-modal *{box-sizing:border-box}
.tt-demo-modal{--tt-purple:#4b1498;--tt-violet:#a66fff;--tt-ink:#080b1b;--tt-muted:#64748b;--tt-border:#e2e8f0;position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:2px;background:rgba(27,33,68,.36);backdrop-filter:blur(5px);font-family:"TTModalInter",Inter,Arial,sans-serif;color:var(--tt-ink)}
.tt-demo-dialog{position:relative;display:grid;grid-template-columns:minmax(0,1.03fr) minmax(0,1fr);width:min(100%,1450px);height:min(99vh,1000px);min-height:0;background:#fff;border-radius:15px;overflow:hidden;box-shadow:0 18px 55px rgba(20,15,55,.2)}
.tt-demo-close{position:absolute;z-index:5;top:20px;right:20px;width:38px;height:38px;display:grid;place-items:center;border:0;background:transparent;color:#535a8b;cursor:pointer;font-size:0}
.tt-demo-close svg{width:29px;height:29px}
.tt-demo-side{position:relative;min-width:0;min-height:0;overflow:hidden;background:#f4f4fd;padding:clamp(28px,5.5vh,58px) 9.5% 26px}
.tt-demo-side-bg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none}
.tt-demo-side-content{position:relative;z-index:1;height:100%;display:flex;flex-direction:column}
.tt-demo-wordmark{display:block;width:clamp(150px,14vw,210px);height:auto;max-height:46px;object-fit:contain;object-position:left center;flex:0 0 auto}
.tt-demo-wordmark span{color:#6326f3}
.tt-demo-side-title{max-width:440px;margin:clamp(28px,5.2vh,58px) 0 12px;font-size:clamp(34px,3.3vw,54px);font-weight:800;line-height:1.12;letter-spacing:-1.6px;color:#080b1b}
.tt-demo-side-title span{display:block;color:var(--tt-purple)}
.tt-demo-side-copy{max-width:355px;font-size:16px;line-height:1.75;color:#5c5a70}
.tt-demo-illustration {
  position: absolute;
  top: 150px;
  right: -10%;
  width: 58%;
  height: 255px;
  object-fit: contain;
  object-position: center;
  filter: drop-shadow(0 10px 14px rgba(75,20,152,.12));
}
  .tt-demo-benefits{display:grid;gap:clamp(14px,2.1vh,25px);margin-top:clamp(20px,3.2vh,35px);max-width:460px;padding:0;list-style:none}
.tt-demo-benefit{display:flex;align-items:center;gap:17px}
.tt-demo-benefit-icon{width:53px;height:53px;flex:0 0 53px;border-radius:12px;background:#e1d5ff;display:grid;place-items:center;color:var(--tt-purple);font-size:25px;font-weight:700}
.tt-demo-benefit-icon img{width:30px;height:30px;object-fit:contain}
.tt-demo-benefit strong{display:block;font-size:18px;font-weight:650;line-height:1.35;color:#080b1b}
.tt-demo-benefit span{display:block;margin-top:3px;font-size:16px;line-height:1.4;color:#080b1b}
.tt-demo-quote{display:flex;gap:22px;align-items:flex-start;margin-top:auto;padding:14px 20px 13px;border-radius:15px;background:#ece8fd;color:#080b1b}
.tt-demo-quote-mark{
  display:flex;
  align-items:center;
  justify-content:center;
  flex:0 0 76px;
  width:76px;
  height:64px;
  border-radius:8px;
  background:#f0e9ff;
  color:var(--tt-purple);
  font-family:Georgia,"Times New Roman",serif;
  font-size:76px;
  font-weight:700;
  line-height:1;
  padding-top:10px;
}
.tt-demo-quote blockquote{margin:0;font-size:16px;line-height:1.5;font-weight:650}
.tt-demo-quote figcaption{margin-top:10px;font-size:15px;line-height:1.55}
.tt-demo-form-panel{min-width:0;min-height:0;overflow:hidden;padding:clamp(30px,7.4vh,76px) clamp(30px,5.6vw,64px) 20px;background:#fff}
.tt-demo-form-title{margin:0;font-size:clamp(30px,2.8vw,46px);line-height:1.15;font-weight:750;letter-spacing:-1.1px;color:#0f172a}
.tt-demo-form-sub{margin:3px 0 clamp(14px,2.5vh,26px);font-size:clamp(15px,1.3vw,20px);line-height:1.4;color:#64748b}
.tt-demo-fields{display:grid;gap:clamp(10px,1.6vh,17px)}
.tt-demo-row{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px}
.tt-demo-field{min-width:0}
.tt-demo-field label{display:block;margin-bottom:4px;font-size:clamp(14px,1.08vw,16px);line-height:1.25;font-weight:600;color:#334155}
.tt-demo-required{color:#ef4444}
.tt-demo-field input,.tt-demo-field select{display:block;width:100%;height:clamp(42px,5vh,51px);padding:0 18px;border:1px solid var(--tt-border);border-radius:7px;background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.04);font-family:inherit;font-size:16px;color:#0f172a;outline:none}
.tt-demo-field input::placeholder,.tt-demo-field select:invalid{color:#94a3b8;opacity:1}
.tt-demo-field select{appearance:none;padding-right:38px;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8'%3E%3Cpath d='M1 1l6 6 6-6' fill='none' stroke='%23334155' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 13px center}
.tt-demo-field input:focus,.tt-demo-field select:focus{border-color:#a66fff;box-shadow:0 0 0 3px rgba(166,111,255,.17)}
.tt-demo-consent{display:flex;align-items:flex-start;gap:12px;margin-top:clamp(14px,2.2vh,22px);color:#8491a7;font-size:clamp(13px,1.08vw,16px);line-height:1.4;cursor:pointer}
.tt-demo-consent input{width:20px;height:20px;flex:0 0 20px;margin:2px 0 0;accent-color:var(--tt-purple)}
.tt-demo-consent a{color:#6332f6;text-decoration:none}
.tt-demo-captcha{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:clamp(8px,1.3vh,14px);font-size:13px;color:#334155}
.tt-demo-captcha input{width:82px;height:34px;border:1px solid var(--tt-border);border-radius:6px;padding:0 10px}
.tt-demo-submit{display:flex;align-items:center;justify-content:center;gap:12px;width:100%;min-height:54px;margin-top:clamp(14px,2.2vh,22px);border:0;border-radius:10px;background:var(--tt-purple);color:#fff;font-family:"TTModalJakarta","TTModalInter",sans-serif;font-size:18px;font-weight:700;cursor:pointer;transition:background .2s ease,opacity .2s ease}
.tt-demo-submit:hover{background:#3d0f7e}
.tt-demo-submit:disabled{opacity:.6;cursor:not-allowed}
.tt-demo-form-note{margin-top:clamp(12px,2vh,20px);text-align:center;font-size:clamp(13px,1.08vw,16px);line-height:1.4;color:#64748b}
@media(max-height:820px) and (min-width:801px){.tt-demo-side{padding-top:22px;padding-bottom:16px}.tt-demo-side-title{margin-top:22px;font-size:clamp(30px,3vw,42px)}.tt-demo-side-copy{font-size:14px;line-height:1.5}.tt-demo-benefits{margin-top:18px;gap:12px}.tt-demo-benefit-icon{width:43px;height:43px;flex-basis:43px}.tt-demo-benefit strong{font-size:15px}.tt-demo-benefit span{font-size:13px}.tt-demo-quote{padding:10px 14px}.tt-demo-form-panel{padding-top:24px}.tt-demo-form-sub{margin-bottom:12px}.tt-demo-fields{gap:9px}.tt-demo-field input,.tt-demo-field select{height:39px}.tt-demo-consent{margin-top:11px}.tt-demo-captcha{margin-top:7px}.tt-demo-captcha input{height:30px}.tt-demo-submit{min-height:45px;margin-top:10px}.tt-demo-form-note{margin-top:9px}}
@media(max-width:1050px){.tt-demo-dialog{grid-template-columns:minmax(0,.88fr) minmax(0,1fr)}.tt-demo-side{padding-left:30px;padding-right:25px}.tt-demo-side-title{margin-top:45px}.tt-demo-illustration{opacity:.6;right:-8%;top:165px;width:50%}.tt-demo-form-panel{padding:55px 28px 28px}.tt-demo-benefits{gap:18px}.tt-demo-benefit-icon{width:45px;height:45px;flex-basis:45px}.tt-demo-benefit strong{font-size:16px}.tt-demo-benefit span{font-size:14px}}
@media(max-width:800px){.tt-demo-modal{padding:12px}.tt-demo-dialog{display:block;width:min(100%,620px);height:auto;max-height:96vh;min-height:0;overflow-y:auto;scrollbar-width:none}.tt-demo-dialog::-webkit-scrollbar{display:none}.tt-demo-side{padding:28px 28px 24px;min-height:0}.tt-demo-wordmark{width:170px;max-height:38px}.tt-demo-side-title{margin:26px 0 10px;font-size:36px;max-width:70%}.tt-demo-side-copy{max-width:70%;font-size:15px}.tt-demo-illustration{top:80px;right:0;width:38%;height:180px;opacity:.95}.tt-demo-benefits{grid-template-columns:1fr 1fr;gap:15px;margin-top:25px;max-width:none}.tt-demo-benefit{gap:10px}.tt-demo-benefit-icon{width:39px;height:39px;flex-basis:39px;font-size:19px}.tt-demo-benefit-icon img{width:24px;height:24px}.tt-demo-benefit strong{font-size:14px}.tt-demo-benefit span{font-size:12px}.tt-demo-quote{margin-top:22px}.tt-demo-form-panel{overflow:visible;padding:28px}.tt-demo-form-title{font-size:32px}.tt-demo-form-sub{margin-bottom:22px}.tt-demo-fields{gap:17px}.tt-demo-row{gap:14px}.tt-demo-field label{font-size:14px}.tt-demo-field input,.tt-demo-field select{height:46px;font-size:15px}.tt-demo-submit{min-height:54px}}
@media(max-width:520px){.tt-demo-modal{padding:8px}.tt-demo-dialog{max-height:98vh;border-radius:12px}.tt-demo-close{top:10px;right:10px;width:32px;height:32px}.tt-demo-side{padding:24px 20px 20px}.tt-demo-wordmark{width:150px;max-height:34px}.tt-demo-side-title{margin-top:24px;font-size:30px;max-width:100%;padding-right:0}.tt-demo-side-copy{max-width:100%;font-size:14px;line-height:1.5}.tt-demo-illustration{position:relative;display:block;top:auto;right:auto;width:min(210px,65%);height:120px;margin:-8px 0 -2px auto;opacity:1}.tt-demo-benefits{grid-template-columns:1fr;gap:13px;margin-top:18px}.tt-demo-benefit-icon{width:42px;height:42px;flex-basis:42px}.tt-demo-benefit-icon img{width:25px;height:25px}.tt-demo-benefit strong{font-size:15px}.tt-demo-benefit span{font-size:13px}.tt-demo-quote{gap:13px;padding:13px;margin-top:18px}.tt-demo-quote-mark{flex-basis:58px;width:58px;height:52px;font-size:60px;padding-top:8px}.tt-demo-quote blockquote{font-size:14px}.tt-demo-quote figcaption{font-size:13px}.tt-demo-form-panel{padding:25px 20px 22px}.tt-demo-form-title{font-size:29px;padding-right:25px}.tt-demo-form-sub{font-size:14px;margin-bottom:20px}.tt-demo-row{grid-template-columns:minmax(0,1fr);gap:17px}.tt-demo-fields{gap:17px}.tt-demo-consent{font-size:13px;margin-top:20px}.tt-demo-submit{margin-top:20px;font-size:16px}.tt-demo-form-note{margin-top:17px;font-size:13px}}

/* Desktop sizing refinement: keep the popup compact and fully visible. */
@media (min-width: 801px) {
  .tt-demo-modal { padding: 12px; }
  .tt-demo-dialog {
    width: min(96vw, 1156px);
    height: min(99vh, 794px);
    min-height: 0;
    grid-template-columns: minmax(0, 1.025fr) minmax(0, 1fr);
    border-radius: 14px;
  }
  .tt-demo-side {
    min-height: 0;
    padding: 34px 7.5% 24px;
  }
  .tt-demo-wordmark { font-size: clamp(27px, 2.2vw, 36px); }
  .tt-demo-side-title {
    margin: clamp(24px, 4vh, 38px) 0 10px;
    max-width: 390px;
    font-size: clamp(34px, 3vw, 44px);
    line-height: 1.1;
    letter-spacing: -1.2px;
  }
  .tt-demo-side-copy { max-width: 330px; font-size: 15px; line-height: 1.55; }
  .tt-demo-illustration {
    top: 132px;
    right: -5%;
    width: 55%;
    height: 220px;
  }
  .tt-demo-benefits { gap: 17px; margin-top: 24px; }
  .tt-demo-benefit { gap: 14px; }
  .tt-demo-benefit-icon { width: 46px; height: 46px; flex-basis: 46px; border-radius: 11px; }
  .tt-demo-benefit-icon img { width: 26px; height: 26px; }
  .tt-demo-benefit strong { font-size: 16px; }
  .tt-demo-benefit span { font-size: 14px; }
  .tt-demo-quote { padding: 12px 16px; gap: 16px; }
  .tt-demo-quote-mark { font-size: 52px; }
  .tt-demo-quote blockquote { font-size: 14px; line-height: 1.4; }
  .tt-demo-quote figcaption { margin-top: 7px; font-size: 13px; line-height: 1.45; }

  /* Explicitly neutralize generic global section/form styles that can vertically center the form. */
  .tt-demo-form-panel {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    align-self: stretch;
    min-height: 0;
    overflow: hidden;
    padding: 48px 34px 18px;
  }
  .tt-demo-form-title { flex: 0 0 auto; margin: 0; font-size: 36px; line-height: 1.15; letter-spacing: -.8px; }
  .tt-demo-form-sub { flex: 0 0 auto; margin: 3px 0 17px; font-size: 16px; line-height: 1.4; }
  .tt-demo-fields { gap: 12px; }
  .tt-demo-row { gap: 14px; }
  .tt-demo-field label { margin-bottom: 4px; font-size: 14px; line-height: 1.25; }
  .tt-demo-field input, .tt-demo-field select { height: 42px; padding: 0 14px; font-size: 14px; }
  .tt-demo-consent { margin-top: 17px; gap: 10px; font-size: 13px; line-height: 1.4; }
  .tt-demo-consent input { width: 18px; height: 18px; flex-basis: 18px; }
  .tt-demo-captcha { margin-top: 10px; gap: 8px; font-size: 12px; }
  .tt-demo-captcha input { width: 78px; height: 30px; font-size: 13px; }
  .tt-demo-submit { min-height: 48px; margin-top: 16px; font-size: 16px; border-radius: 8px; }
  .tt-demo-form-note { margin-top: 12px; font-size: 13px; }
}

@media (min-width: 801px) and (max-height: 760px) {
  .tt-demo-dialog { height: 94vh; }
  .tt-demo-side { padding-top: 22px; padding-bottom: 16px; }
  .tt-demo-side-title { margin-top: 20px; font-size: 34px; }
  .tt-demo-illustration {
    top: 100px;
    height: 280px;
    width: 55%;
  }
  .tt-demo-benefits { gap: 12px; margin-top: 18px; }
  .tt-demo-benefit-icon { width: 40px; height: 40px; flex-basis: 40px; }
  .tt-demo-form-panel { padding-top: 24px; }
  .tt-demo-form-sub { margin-bottom: 10px; }
  .tt-demo-fields { gap: 8px; }
  .tt-demo-field input, .tt-demo-field select { height: 36px; }
  .tt-demo-consent { margin-top: 10px; }
  .tt-demo-captcha { margin-top: 6px; }
  .tt-demo-submit { min-height: 42px; margin-top: 8px; }
  .tt-demo-form-note { margin-top: 7px; }
}

@media (min-width: 801px) {
  .tt-demo-form-panel > form { width: 100%; margin: 0; }
}



/* Final desktop form spacing override: scoped to this modal to avoid global CSS conflicts. */
@media (min-width: 801px) {
  .tt-demo-modal .tt-demo-dialog {
    width: min(96vw, 1156px);
    height: min(96vh, 794px);
    min-height: 0;
  }

  .tt-demo-modal .tt-demo-form-panel {
    display: block !important;
    align-self: stretch;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    padding: 28px 30px 14px !important;
    text-align: left;
  }

  .tt-demo-modal .tt-demo-form-panel > form {
    display: block !important;
    width: 100% !important;
    max-width: none !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: none !important;
  }

  .tt-demo-modal .tt-demo-form-title {
    margin: 0 !important;
    font-size: clamp(30px, 2.6vw, 36px);
    line-height: 1.12;
  }

  .tt-demo-modal .tt-demo-form-sub {
    margin: 4px 0 12px !important;
    font-size: 15px;
    line-height: 1.35;
  }

  .tt-demo-modal .tt-demo-fields {
    display: grid !important;
    gap: 8px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .tt-demo-modal .tt-demo-row {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .tt-demo-modal .tt-demo-field {
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
  }

  .tt-demo-modal .tt-demo-field label {
    margin: 0 0 3px !important;
    font-size: 13px;
    line-height: 1.2;
  }

  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 38px !important;
    min-height: 38px !important;
    margin: 0 !important;
    padding: 0 12px !important;
    font-size: 14px;
    line-height: normal;
  }

  .tt-demo-modal .tt-demo-consent {
    margin: 10px 0 0 !important;
    gap: 8px;
    font-size: 12px;
    line-height: 1.3;
  }

  .tt-demo-modal .tt-demo-consent input {
    width: 17px;
    height: 17px;
    flex-basis: 17px;
    margin-top: 1px;
  }

  .tt-demo-modal .tt-demo-captcha {
    margin: 6px 0 0 !important;
    gap: 7px;
    font-size: 12px;
    line-height: 1.2;
  }

  .tt-demo-modal .tt-demo-captcha input {
    width: 76px;
    height: 28px !important;
    min-height: 28px !important;
    margin: 0 !important;
    font-size: 13px;
  }

  .tt-demo-modal .tt-demo-submit {
    min-height: 44px !important;
    height: 44px;
    margin: 10px 0 0 !important;
    padding: 0 14px !important;
    font-size: 16px;
    line-height: 1.2;
  }

  .tt-demo-modal .tt-demo-form-note {
    margin: 8px 0 0 !important;
    font-size: 12px;
    line-height: 1.3;
  }
}

/* Preserve the compact spacing on short desktop/laptop screens. */
@media (min-width: 801px) and (max-height: 760px) {
  .tt-demo-modal .tt-demo-form-panel {
    padding-top: 18px !important;
    padding-bottom: 10px !important;
  }

  .tt-demo-modal .tt-demo-form-sub {
    margin-bottom: 8px !important;
  }

  .tt-demo-modal .tt-demo-fields {
    gap: 6px !important;
  }

  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 34px !important;
    min-height: 34px !important;
  }

  .tt-demo-modal .tt-demo-consent {
    margin-top: 7px !important;
  }

  .tt-demo-modal .tt-demo-captcha {
    margin-top: 4px !important;
  }

  .tt-demo-modal .tt-demo-submit {
    height: 40px;
    min-height: 40px !important;
    margin-top: 7px !important;
  }

  .tt-demo-modal .tt-demo-form-note {
    margin-top: 5px !important;
  }
}



/* Final form polish: balanced spacing and cleaner native select menus. */
@media (min-width: 801px) {
  .tt-demo-modal .tt-demo-form-panel {
    padding: 26px 30px 14px !important;
  }

  .tt-demo-modal .tt-demo-form-sub {
    margin-bottom: 15px !important;
  }

  .tt-demo-modal .tt-demo-fields {
    gap: 12px !important;
  }

  .tt-demo-modal .tt-demo-row {
    gap: 14px !important;
  }

  .tt-demo-modal .tt-demo-field label {
    margin-bottom: 4px !important;
    line-height: 1.25;
  }

  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 39px !important;
    min-height: 39px !important;
  }

  .tt-demo-modal .tt-demo-consent {
    margin-top: 12px !important;
  }

  .tt-demo-modal .tt-demo-captcha {
    margin-top: 8px !important;
  }

  .tt-demo-modal .tt-demo-submit {
    margin-top: 12px !important;
  }

  .tt-demo-modal .tt-demo-form-note {
    margin-top: 9px !important;
  }
}

/* Keep select controls readable and visually consistent with the modal. */
.tt-demo-modal .tt-demo-field select {
  color: #334155;
  background-color: #fff;
  border-color: #dbe3ef;
  cursor: pointer;
}

.tt-demo-modal .tt-demo-field select:focus {
  border-color: #a66fff;
  outline: none;
  box-shadow: 0 0 0 3px rgba(166, 111, 255, .18);
}

.tt-demo-modal .tt-demo-field select option {
  max-width: 100%;
  color: #334155;
  background: #fff;
  font-size: 13px;
}

.tt-demo-modal .tt-demo-field select option:disabled {
  color: #94a3b8;
}

@media (min-width: 801px) and (max-height: 760px) {
  .tt-demo-modal .tt-demo-fields { gap: 8px !important; }
  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 35px !important;
    min-height: 35px !important;
  }
}



/* Final layout: use the available panel height and give Hiring Challenge its own row. */
@media (min-width: 801px) {
  .tt-demo-modal .tt-demo-dialog {
    height: min(96vh, 820px);
  }

  .tt-demo-modal .tt-demo-form-panel {
    display: flex !important;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 0;
    padding: 28px 30px 20px !important;
  }

  .tt-demo-modal .tt-demo-form-panel > form {
    display: flex !important;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }

  .tt-demo-modal .tt-demo-form-sub {
    margin-bottom: 17px !important;
  }

  .tt-demo-modal .tt-demo-fields {
    gap: 13px !important;
  }

  .tt-demo-modal .tt-demo-row {
    gap: 14px !important;
  }

  .tt-demo-modal .tt-demo-challenge-field {
    width: 100%;
  }

  .tt-demo-modal .tt-demo-field label {
    margin-bottom: 5px !important;
  }

  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 40px !important;
    min-height: 40px !important;
  }

  .tt-demo-modal .tt-demo-consent {
    margin-top: 13px !important;
  }

  .tt-demo-modal .tt-demo-captcha {
    margin-top: 9px !important;
  }

  .tt-demo-modal .tt-demo-submit {
    margin-top: 13px !important;
  }

  .tt-demo-modal .tt-demo-form-note {
    margin-top: 10px !important;
  }
}

@media (min-width: 801px) and (max-height: 760px) {
  .tt-demo-modal .tt-demo-dialog {
    height: 98vh;
  }

  .tt-demo-modal .tt-demo-form-panel {
    padding-top: 16px !important;
    padding-bottom: 10px !important;
  }

  .tt-demo-modal .tt-demo-form-sub {
    margin-bottom: 9px !important;
  }

  .tt-demo-modal .tt-demo-fields {
    gap: 7px !important;
  }

  .tt-demo-modal .tt-demo-field input,
  .tt-demo-modal .tt-demo-field select {
    height: 34px !important;
    min-height: 34px !important;
  }

  .tt-demo-modal .tt-demo-consent {
    margin-top: 7px !important;
  }

  .tt-demo-modal .tt-demo-captcha {
    margin-top: 4px !important;
  }

  .tt-demo-modal .tt-demo-submit {
    margin-top: 7px !important;
  }

  .tt-demo-modal .tt-demo-form-note {
    margin-top: 5px !important;
  }
}



/* Requested final refinements */
.tt-demo-modal .tt-demo-form-sub {
  max-width: 390px;
  line-height: 1.4;
}

.tt-demo-modal .tt-demo-captcha {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.tt-demo-modal .tt-demo-captcha input {
  appearance: textfield;
  -moz-appearance: textfield;
}

.tt-demo-modal .tt-demo-captcha input::-webkit-outer-spin-button,
.tt-demo-modal .tt-demo-captcha input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (min-width: 801px) {
  .tt-demo-modal .tt-demo-form-sub {
    max-width: 390px;
  }

  .tt-demo-modal .tt-demo-captcha {
    justify-content: center;
  }
}



/* Testimonial card styled to match the supplied reference image. */
.tt-demo-modal .tt-demo-quote {
  width: 100%;
  max-width: 510px;
  display: flex;
  align-items: flex-start;
  gap: 22px;
  padding: 14px 20px 13px;
  margin-bottom: 60px;
  border-radius: 15px;
  background: #ece8fd;
  box-sizing: border-box;
  transform: translateY(-45px);
}

.tt-demo-modal .tt-demo-quote-mark {
  display: block;
  flex: 0 0 40px;
  width: 40px;
  height: auto;
  padding: 0;
  margin-top: 1px;
  border-radius: 0;
  background: transparent;
  color: #4b1498;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 62px;
  font-weight: 800;
  line-height: .85;
}

.tt-demo-modal .tt-demo-quote blockquote {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 650;
}

.tt-demo-modal .tt-demo-quote figcaption {
  margin-top: 10px;
  font-size: 15px;
  line-height: 1.55;
}

/* Final illustration adjustment: move it right and make it slightly larger. */
@media (min-width: 801px) {
  .tt-demo-modal .tt-demo-illustration {
    top: 116px;
    right: -10%;
    width: 66%;
    height: 280px;
  }
}

@media (min-width: 801px) and (max-height: 760px) {
  .tt-demo-modal .tt-demo-illustration {
    top: 92px;
    right: -10%;
    width: 64%;
    height: 292px;
  }
}

/* The dialog must scroll when its contents exceed a short viewport. */
@media (min-width:1281px){
  .tt-demo-modal .tt-demo-dialog{max-height:calc(100dvh - 24px)}
  .tt-demo-modal .tt-demo-form-panel{overflow-y:auto;overscroll-behavior:contain}
  .tt-demo-modal .tt-demo-side{overflow-y:auto;overscroll-behavior:contain}
  .tt-demo-modal .tt-demo-quote{margin-bottom:0;transform:none}
}
@media (max-width:800px){
  .tt-demo-modal .tt-demo-dialog{max-height:calc(100dvh - 24px);scrollbar-width:auto}
  .tt-demo-modal .tt-demo-quote{margin-bottom:0;transform:none}
  .tt-demo-modal .tt-demo-side-content{height:auto}
  .tt-demo-modal .tt-demo-form-panel{overflow:visible}
}
@media (max-width:520px){
  .tt-demo-modal .tt-demo-dialog{max-height:calc(100dvh - 16px)}
  .tt-demo-modal .tt-demo-field input,.tt-demo-modal .tt-demo-field select,.tt-demo-modal .tt-demo-captcha input{font-size:16px}
  .tt-demo-modal .tt-demo-quote{gap:12px;padding:12px}
  .tt-demo-modal .tt-demo-quote-mark{flex-basis:30px;width:30px;font-size:48px}
  .tt-demo-modal .tt-demo-quote blockquote{font-size:14px}
  .tt-demo-modal .tt-demo-quote figcaption{font-size:13px}
}

/* Viriqo Hires reference finish — these declarations intentionally sit last so
   the dialog retains the supplied reference's visual system despite page-level
   form styles elsewhere in the application. */
.tt-demo-modal{--tt-ink:#0B1F44;--tt-purple:#6A1B9A;--tt-violet:#00AEEF;--tt-border:#E3E7EE;color:#0B1F44}
.tt-demo-modal .tt-demo-dialog{box-shadow:0 20px 58px rgba(11,31,68,.22)}
.tt-demo-modal .tt-demo-side{background:#F4F4FD}
.tt-demo-modal .tt-demo-wordmark{width:214px;height:auto;object-fit:contain;object-position:left center}
.tt-demo-modal .tt-demo-side-title{color:#0B1F44;font-weight:800}
.tt-demo-modal .tt-demo-side-title span{color:#6A1B9A;background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}
.tt-demo-modal .tt-demo-side-copy{color:#4B5563}
.tt-demo-modal .tt-demo-benefit-icon{width:56px;height:56px;flex-basis:56px;border-radius:12px}
.tt-demo-modal .tt-demo-benefit strong,.tt-demo-modal .tt-demo-benefit span{color:#0B1F44}
.tt-demo-modal .tt-demo-quote{background:#F1E8FD}
.tt-demo-modal .tt-demo-quote-mark{color:#6A1B9A}
.tt-demo-modal .tt-demo-form-title{color:#0B1F44;font-weight:700}
.tt-demo-modal .tt-demo-form-sub{color:#6B7280}
.tt-demo-modal .tt-demo-field label{color:#334155;font-weight:600}
.tt-demo-modal .tt-demo-field input,.tt-demo-modal .tt-demo-field select{border-color:#E3E7EE;color:#0B1F44;border-radius:6px}
.tt-demo-modal .tt-demo-field input:focus,.tt-demo-modal .tt-demo-field select:focus{border-color:#00AEEF;box-shadow:0 0 0 3px rgba(0,174,239,.20)}
.tt-demo-modal .tt-demo-consent{color:#8A94A6}
.tt-demo-modal .tt-demo-consent a{color:#3A5BC7}
.tt-demo-modal .tt-demo-submit{background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%)}
.tt-demo-modal .tt-demo-submit:hover{background:linear-gradient(125deg,#009ed9 0%,#314eaf 45%,#57137e 90%)}
.tt-demo-modal .tt-demo-form-note{color:#6B7280}

/* The reference dialog is 796px tall, but the working form has a required
   captcha in addition to the reference fields.  On short laptop windows the
   form panel therefore becomes its own contained scroll region instead of
   hiding the captcha and primary conversion action below its bottom edge. */
@media (min-width:801px){
  .tt-demo-modal .tt-demo-dialog{min-height:0}
  .tt-demo-modal .tt-demo-form-panel{
    min-height:0;
    overflow-y:auto !important;
    overflow-x:hidden;
    overscroll-behavior:contain;
    scrollbar-gutter:stable;
    padding-bottom:28px !important;
  }
}
/* Figma-aligned form proportions and compact stacked mobile dialog. */
@media (min-width:801px){
  .tt-demo-modal .tt-demo-dialog{width:min(94vw,1120px);height:min(94vh,780px)}
  .tt-demo-modal .tt-demo-side{padding:32px 7% 22px}
  .tt-demo-modal .tt-demo-side-title{font-size:clamp(32px,2.8vw,42px);margin-top:30px}
  .tt-demo-modal .tt-demo-side-copy{font-size:14px;line-height:1.55}
  .tt-demo-modal .tt-demo-illustration{top:124px;right:-6%;width:55%;height:212px}
  .tt-demo-modal .tt-demo-benefits{margin-top:22px;gap:14px}
  .tt-demo-modal .tt-demo-benefit{gap:12px}
  .tt-demo-modal .tt-demo-benefit-icon{width:42px;height:42px;flex-basis:42px;border-radius:10px}
  .tt-demo-modal .tt-demo-benefit-icon img{width:23px;height:23px}
  .tt-demo-modal .tt-demo-benefit strong{font-size:15px}
  .tt-demo-modal .tt-demo-benefit span{font-size:13px}
  .tt-demo-modal .tt-demo-form-panel{padding:30px 32px 20px!important}
  .tt-demo-modal .tt-demo-form-title{font-size:32px}
  .tt-demo-modal .tt-demo-form-sub{font-size:14px!important;margin-bottom:13px!important}
  .tt-demo-modal .tt-demo-row{grid-template-columns:repeat(2,minmax(0,1fr));gap:14px!important}
  .tt-demo-modal .tt-demo-field input,.tt-demo-modal .tt-demo-field select{height:40px!important;min-height:40px!important;padding-inline:13px!important}
  .tt-demo-modal .tt-demo-captcha{justify-content:flex-start;text-align:left}
}
@media (max-width:800px){
  .tt-demo-modal{align-items:flex-start;padding:12px}
  .tt-demo-modal .tt-demo-dialog{margin:0 auto;max-height:calc(100dvh - 24px)}
  .tt-demo-modal .tt-demo-close{top:12px;right:12px;width:30px;height:30px}
  .tt-demo-modal .tt-demo-close svg{width:20px;height:20px}
  .tt-demo-modal .tt-demo-side{padding:24px 24px 20px}
  .tt-demo-modal .tt-demo-side-title{font-size:30px;line-height:1.13;padding-right:30px;max-width:100%}
  .tt-demo-modal .tt-demo-side-copy{font-size:14px;max-width:100%}
  .tt-demo-modal .tt-demo-illustration{position:relative;top:auto;right:auto;width:min(205px,62%);height:118px;margin:4px 0 4px auto}
  .tt-demo-modal .tt-demo-benefits{grid-template-columns:1fr;gap:12px;margin-top:16px}
  .tt-demo-modal .tt-demo-benefit-icon{width:40px;height:40px;flex-basis:40px}
  .tt-demo-modal .tt-demo-quote{margin-top:16px}
  .tt-demo-modal .tt-demo-form-panel{padding:24px!important}
  .tt-demo-modal .tt-demo-form-title{font-size:28px;padding-right:30px}
  .tt-demo-modal .tt-demo-fields{gap:14px!important}
  .tt-demo-modal .tt-demo-row{gap:14px!important}
  .tt-demo-modal .tt-demo-field input,.tt-demo-modal .tt-demo-field select{height:44px!important}
  .tt-demo-modal .tt-demo-captcha{justify-content:flex-start;text-align:left}
}
@media (max-width:520px){
  .tt-demo-modal{padding:8px}
  .tt-demo-modal .tt-demo-side,.tt-demo-modal .tt-demo-form-panel{padding-left:20px!important;padding-right:20px!important}
  .tt-demo-modal .tt-demo-side{padding-top:22px}
  .tt-demo-modal .tt-demo-wordmark{width:136px}
  .tt-demo-modal .tt-demo-side-title{font-size:27px}
  .tt-demo-modal .tt-demo-quote{display:none}
  .tt-demo-modal .tt-demo-submit{min-height:48px;font-size:15px}
}

/* Left showcase panel: fixed laptop/desktop geometry from the approved
   reference. Keep the reading column left-aligned and reserve the right edge
   for the illustration, without introducing a panel-specific scrollbar. */
@media (min-width:801px){
  .tt-demo-modal .tt-demo-dialog{
    height:calc(100dvh - 2px);
    max-height:790px;
  }
  .tt-demo-modal .tt-demo-side{
    padding:38px 0 28px 67px;
    overflow:hidden;
  }
  .tt-demo-modal .tt-demo-side-content{height:100%;min-height:0;align-items:flex-start;text-align:left;}
  .tt-demo-modal .tt-demo-wordmark{width:215px;max-height:none;object-position:left center;}
  .tt-demo-modal .tt-demo-side-title{
    width:390px;max-width:390px;margin:50px 0 12px;
    font-size:44px;line-height:1.1;letter-spacing:-1.6px;text-align:left!important;
  }
  .tt-demo-modal .tt-demo-side-copy{
    width:290px;max-width:290px;font-size:16px;line-height:1.45;text-align:left!important;
  }
  .tt-demo-modal .tt-demo-illustration{
    position:absolute;top:104px;right:-26px;width:266px;height:332px;margin:0;opacity:1;
  }
  .tt-demo-modal .tt-demo-benefits{
    display:grid;width:305px;max-width:305px;grid-template-columns:1fr;
    gap:27px;margin-top:34px;text-align:left;
  }
  .tt-demo-modal .tt-demo-benefit{gap:14px;text-align:left;}
  .tt-demo-modal .tt-demo-benefit-icon{width:42px;height:42px;flex-basis:42px;border-radius:9px;}
  .tt-demo-modal .tt-demo-benefit-icon img{width:24px;height:24px;}
  .tt-demo-modal .tt-demo-benefit strong{font-size:16px;line-height:1.25;}
  .tt-demo-modal .tt-demo-benefit span{margin-top:2px;font-size:14px;line-height:1.3;}
  .tt-demo-modal .tt-demo-quote{
    width:408px;max-width:calc(100% - 67px);min-height:114px;margin-top:36px;
    padding:14px 18px;gap:16px;border-radius:12px;text-align:left!important;
  }
  .tt-demo-modal .tt-demo-quote-mark{width:44px;flex-basis:44px;font-size:66px;}
  .tt-demo-modal .tt-demo-quote blockquote{font-size:14px;line-height:1.45;text-align:left!important;}
  .tt-demo-modal .tt-demo-quote figcaption{margin-top:7px;font-size:14px;line-height:1.4;text-align:left!important;}
}

/* Laptop scale: retain the desktop layout without making the dialog feel
   oversized on shorter/narrower notebook screens. */
@media (min-width:801px) and (max-width:1280px){
  .tt-demo-modal .tt-demo-dialog{
    width:min(94vw,1080px);
    height:min(92vh,740px);
  }
  .tt-demo-modal .tt-demo-side{padding-left:52px;padding-top:30px;}
  .tt-demo-modal .tt-demo-wordmark{width:195px;}
  .tt-demo-modal .tt-demo-side-title{
    width:350px;max-width:350px;margin-top:40px;font-size:40px;
  }
  .tt-demo-modal .tt-demo-side-copy{font-size:14px;line-height:1.5;}
  .tt-demo-modal .tt-demo-illustration{
    top:92px;right:-38px;width:226px;height:282px;
  }
  .tt-demo-modal .tt-demo-benefits{max-width:280px;gap:21px;margin-top:27px;}
  .tt-demo-modal .tt-demo-benefit-icon{width:40px;height:40px;flex-basis:40px;}
  .tt-demo-modal .tt-demo-benefit-icon img{width:23px;height:23px;}
  .tt-demo-modal .tt-demo-benefit strong{font-size:15px;}
  .tt-demo-modal .tt-demo-benefit span{font-size:13px;}
  .tt-demo-modal .tt-demo-quote{margin-top:27px;min-height:0;padding:12px 15px;}
  .tt-demo-modal .tt-demo-quote blockquote{font-size:13px;}
  .tt-demo-modal .tt-demo-quote figcaption{font-size:13px;}
}

/* Keep high-resolution laptop browsers from expanding the dialog beyond the
   approved desktop reference proportions. */
@media (min-width:1281px){
  .tt-demo-modal .tt-demo-dialog{
    width:min(94vw,1180px);
    height:min(94vh,790px);
    max-height:calc(100dvh - 24px);
  }
}

/* The supplied benefit SVGs include their own lavender tile. Render each SVG
   at the full tile size so the purple glyph is visually substantial and
   perfectly centered rather than shrinking it inside a second box. */
.tt-demo-modal .tt-demo-benefit-icon{
  display:grid;
  place-items:center;
  padding:0;
  overflow:hidden;
  background:transparent;
}
.tt-demo-modal .tt-demo-benefit-icon img{
  display:block;
  width:100%;
  height:100%;
  max-width:none;
  max-height:none;
  object-fit:contain;
}

/* Tablet and phone: stack the showcase in reading order.  The illustration
   must participate in the flow here, rather than floating in a large empty
   area beside centered copy. */
@media (max-width:800px){
  .tt-demo-modal .tt-demo-side{
    padding:26px 24px 28px;
  }
  .tt-demo-modal .tt-demo-side-content{
    height:auto;
    align-items:flex-start;
    text-align:left;
  }
  .tt-demo-modal .tt-demo-wordmark{
    width:180px;
    max-height:none;
    object-position:left center;
  }
  .tt-demo-modal .tt-demo-side-title{
    width:auto;
    max-width:100%;
    margin:28px 0 12px;
    padding:0;
    font-size:34px;
    line-height:1.12;
    text-align:left !important;
  }
  .tt-demo-modal .tt-demo-side-copy{
    width:auto;
    max-width:100%;
    font-size:15px;
    line-height:1.52;
    text-align:left !important;
  }
  .tt-demo-modal .tt-demo-illustration{
    position:relative;
    top:auto;
    right:auto;
    display:block;
    width:min(220px,62vw);
    height:auto;
    margin:12px 0 24px auto;
    opacity:1;
  }
  .tt-demo-modal .tt-demo-benefits{
    display:grid;
    width:100%;
    max-width:none;
    grid-template-columns:1fr;
    gap:16px;
    margin-top:0;
    text-align:left;
  }
  .tt-demo-modal .tt-demo-benefit{gap:13px;text-align:left;}
  .tt-demo-modal .tt-demo-benefit-icon{width:44px;height:44px;flex-basis:44px;}
  .tt-demo-modal .tt-demo-benefit strong{font-size:16px;}
  .tt-demo-modal .tt-demo-benefit span{font-size:14px;}
  .tt-demo-modal .tt-demo-quote{
    width:100%;
    max-width:none;
    margin-top:24px;
    text-align:left !important;
  }
  .tt-demo-modal .tt-demo-quote blockquote,
  .tt-demo-modal .tt-demo-quote figcaption{text-align:left !important;}
}
@media (max-width:520px){
  .tt-demo-modal .tt-demo-side{padding:22px 20px 24px;}
  .tt-demo-modal .tt-demo-wordmark{width:156px;}
  .tt-demo-modal .tt-demo-side-title{margin-top:24px;font-size:30px;}
  .tt-demo-modal .tt-demo-side-copy{font-size:14px;}
  .tt-demo-modal .tt-demo-illustration{width:min(190px,60vw);margin:10px 0 20px auto;}
  .tt-demo-modal .tt-demo-benefit-icon{width:42px;height:42px;flex-basis:42px;}
}
`;

const ContactModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    lookingFor: "",
    email: "",
    firstName: "",
    lastName: "",
    contactNumber: "",
    employees: "",
    jobTitle: "",
    companyName: "",
    challengeDescription: "",
    agree: false,
    captchaAnswer: "",
  });

  const [captcha, setCaptcha] = useState({
    id: "",
    question: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const { notify } = useNotification();

  // Fetch captcha when modal opens
  useEffect(() => {
    if (isOpen) {
      fetchCaptcha();
    }
  }, [isOpen]);

  const fetchCaptcha = async () => {
    try {
      const response = await generateCaptcha();
      setCaptcha({
        id: response.captcha_id,
        question: response.question,
      });
    } catch (error) {
      console.error("Failed to generate captcha:", error);
      notify("error", "Failed to load captcha. Please try again.");
    }
  };

  const handleInputChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Validate required fields
      if (
        !form.lookingFor ||
        !form.email ||
        !form.firstName ||
        !form.lastName ||
        !form.contactNumber ||
        !form.employees ||
        !form.challengeDescription
      ) {
        notify("error", "Please fill in all required fields");
        setIsLoading(false);
        return;
      }

      if (!form.agree) {
        notify("error", "Please agree to the privacy policy and terms");
        setIsLoading(false);
        return;
      }

      if (!form.captchaAnswer) {
        notify("error", "Please answer the captcha");
        setIsLoading(false);
        return;
      }

      const contactData = {
        lookingFor: form.lookingFor,
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        contactNumber: form.contactNumber,
        employees: form.employees,
        jobTitle: form.jobTitle,
        companyName: form.companyName,
        challengeDescription: form.challengeDescription,
        captcha_id: captcha.id,
        captchaAnswer: parseInt(form.captchaAnswer),
        tracking: createTrackingContext({
          cta: "Request a Demo",
          organization: form.companyName,
          useLatestCta: true,
        }),
      };

      await submitContactForm(contactData);
      completeJourney();
      console.log("Contact form submitted successfully");
      notify("success", "Thanks! We'll reach out soon.");
      setIsLoading(false);

      // Reset form
      setForm({
        lookingFor: "",
        email: "",
        firstName: "",
        lastName: "",
        contactNumber: "",
        employees: "",
        jobTitle: "",
        companyName: "",
        challengeDescription: "",
        agree: false,
        captchaAnswer: "",
      });

      // Close modal
      onClose();
      navigate("/demo-thankyou");
    } catch (error) {
      notify(
        "error",
        error.message || "Failed to submit contact form. Please try again.",
      );
      // Refresh captcha on error
      fetchCaptcha();
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{TT_CONTACT_MODAL_CSS}</style>
      <div
        className="tt-demo-modal"
        role="presentation"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div
          className="tt-demo-dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="tt-demo-title"
        >
          <button
            type="button"
            className="tt-demo-close"
            aria-label="Close demo request"
            onClick={onClose}
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M3 3l18 18M21 3L3 21"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </button>

          <aside className="tt-demo-side">
            <img
              className="tt-demo-side-bg"
              src={demoPanelBackground}
              alt=""
              aria-hidden="true"
            />
            <div className="tt-demo-side-content">
              <img className="tt-demo-wordmark" src={logo} alt="TalentTalks" />
              <h2 className="tt-demo-side-title">
                See Viriqo Hires <span>in Action</span>
              </h2>
              <p className="tt-demo-side-copy">
                Get a personalized demo and see how AI can help you hire
                technical talent faster and smarter.
              </p>
              <img
                className="tt-demo-illustration"
                src={demoIllustration}
                alt="TalentTalks product preview"
              />
              <ul className="tt-demo-benefits">
                <li className="tt-demo-benefit">
                  <span className="tt-demo-benefit-icon" aria-hidden="true">
                    <img src={tailoredIcon} alt="" />
                  </span>
                  <div>
                    <strong>Tailored to your needs</strong>
                    <span>See how it fits your hiring process</span>
                  </div>
                </li>
                <li className="tt-demo-benefit">
                  <span className="tt-demo-benefit-icon" aria-hidden="true">
                    <img src={expertGuidanceIcon} alt="" />
                  </span>
                  <div>
                    <strong>Get expert guidance</strong>
                    <span>From our product specialists</span>
                  </div>
                </li>
                <li className="tt-demo-benefit">
                  <span className="tt-demo-benefit-icon" aria-hidden="true">
                    <img src={useCasesIcon} alt="" />
                  </span>
                  <div>
                    <strong>Explore real use cases</strong>
                    <span>Relevant to your industry</span>
                  </div>
                </li>
              </ul>
              <figure className="tt-demo-quote">
                <span className="tt-demo-quote-mark" aria-hidden="true">
                  “
                </span>
                <div>
                  <blockquote>
                    "Viriqo Hires helped us reduce our hiring
                    <br />
                    time by 3x.”
                  </blockquote>
                  <figcaption>
                    — Head of Engineering
                    <br />
                    Mid-size SaaS Company
                  </figcaption>
                </div>{" "}
              </figure>
            </div>
          </aside>

          <section className="tt-demo-form-panel">
            <h2 className="tt-demo-form-title" id="tt-demo-title">
              Request a Demo
            </h2>
            <p className="tt-demo-form-sub">
              Tell us a few details and our team will get in touch
              <br />
              with you shortly.
            </p>

            <form onSubmit={handleSubmit} noValidate>
              <div className="tt-demo-fields">
                <div className="tt-demo-row">
                  <div className="tt-demo-field">
                    <label htmlFor="tt-first">
                      First Name <span className="tt-demo-required">*</span>
                    </label>
                    <input
                      id="tt-first"
                      name="firstName"
                      value={form.firstName}
                      onChange={(e) =>
                        handleInputChange("firstName", e.target.value)
                      }
                      placeholder="John"
                      autoComplete="given-name"
                      required
                    />
                  </div>
                  <div className="tt-demo-field">
                    <label htmlFor="tt-last">
                      Last Name <span className="tt-demo-required">*</span>
                    </label>
                    <input
                      id="tt-last"
                      name="lastName"
                      value={form.lastName}
                      onChange={(e) =>
                        handleInputChange("lastName", e.target.value)
                      }
                      placeholder="Doe"
                      autoComplete="family-name"
                      required
                    />
                  </div>
                </div>
                <div className="tt-demo-field">
                  <label htmlFor="tt-email">
                    Work Email <span className="tt-demo-required">*</span>
                  </label>
                  <input
                    id="tt-email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    placeholder="you@company.com"
                    autoComplete="email"
                    required
                  />
                </div>
                <div className="tt-demo-row">
                  <div className="tt-demo-field">
                    <label htmlFor="tt-company">
                      Company Name <span className="tt-demo-required">*</span>
                    </label>
                    <input
                      id="tt-company"
                      name="companyName"
                      value={form.companyName}
                      onChange={(e) =>
                        handleInputChange("companyName", e.target.value)
                      }
                      placeholder="Company name"
                      autoComplete="organization"
                      required
                    />
                  </div>
                  <div className="tt-demo-field">
                    <label htmlFor="tt-job">Job Title</label>
                    <input
                      id="tt-job"
                      name="jobTitle"
                      value={form.jobTitle}
                      onChange={(e) =>
                        handleInputChange("jobTitle", e.target.value)
                      }
                      placeholder="Job title"
                      autoComplete="organization-title"
                    />
                  </div>
                </div>
                <div className="tt-demo-row">
                  <div className="tt-demo-field">
                    <label htmlFor="tt-employees">
                      # of Employees <span className="tt-demo-required">*</span>
                    </label>
                    <select
                      id="tt-employees"
                      name="employees"
                      value={form.employees}
                      onChange={(e) =>
                        handleInputChange("employees", e.target.value)
                      }
                      required
                    >
                      <option value="" disabled>
                        Select range
                      </option>
                      {[
                        "<50",
                        "50-249",
                        "250-499",
                        "450-999",
                        "1000-2999",
                        "5000+",
                      ].map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="tt-demo-field">
                    <label htmlFor="tt-looking">
                      I’m looking to <span className="tt-demo-required">*</span>
                    </label>
                    <select
                      id="tt-looking"
                      name="lookingFor"
                      value={form.lookingFor}
                      onChange={(e) =>
                        handleInputChange("lookingFor", e.target.value)
                      }
                      required
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      {[
                        "Schedule a demo",
                        "Speak with Sales",
                        "Speak with Support",
                      ].map((option) => (
                        <option key={option}>{option}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="tt-demo-row">
                  <div className="tt-demo-field">
                    <label htmlFor="tt-phone">
                      Contact Number <span className="tt-demo-required">*</span>
                    </label>
                    <input
                      id="tt-phone"
                      name="contactNumber"
                      type="tel"
                      value={form.contactNumber}
                      onChange={(e) =>
                        handleInputChange("contactNumber", e.target.value)
                      }
                      placeholder="Contact number"
                      autoComplete="tel"
                      required
                    />
                  </div>
                </div>
                <div className="tt-demo-field tt-demo-challenge-field">
                  <label htmlFor="tt-challenge">
                    Hiring Challenge <span className="tt-demo-required">*</span>
                  </label>
                  <select
                    id="tt-challenge"
                    name="challengeDescription"
                    value={form.challengeDescription}
                    onChange={(e) =>
                      handleInputChange("challengeDescription", e.target.value)
                    }
                    required
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    {[
                      "Need to accelerate/increase scale and efficiency of hiring",
                      "Availability of reporting and data tied to Talent Acquisition",
                      "Security and compliance concerns related to Talent Acquisition/AI in Talent Acquisition",
                      "Budget and resourcing constraints for resourcing",
                      "I am not happy with my current Talent Acquisition tech stack",
                      "Challenges integrating with existing Talent Acquisition tech stack",
                      "Need to enhance our AI capabilities in Talent Acquisition",
                    ].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <label className="tt-demo-consent">
                <input
                  type="checkbox"
                  checked={form.agree}
                  onChange={(e) => handleInputChange("agree", e.target.checked)}
                />
                <span>
                  I agree to receive periodic communications from Viriqo Hires. I
                  can read the{" "}
                  <a href="/privacy-policy" target="_blank" rel="noreferrer">
                    Privacy Policy
                  </a>
                  .
                </span>
              </label>

              <div className="tt-demo-captcha">
                <strong>
                  {captcha.question || "Loading captcha…"}{" "}
                  {captcha.question ? "=" : ""}
                </strong>
                <input
                  aria-label="Captcha answer"
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  value={form.captchaAnswer}
                  onChange={(e) =>
                    handleInputChange("captchaAnswer", e.target.value)
                  }
                  placeholder="Answer"
                  required
                />
              </div>

              <button
                type="submit"
                className="tt-demo-submit"
                disabled={isLoading}
              >
                <span>{isLoading ? "Submitting..." : "Request a Demo"}</span>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 7h15M10 1l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <p className="tt-demo-form-note">
                Our team will get back to you within 1 business day.
              </p>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default ContactModal;
